import React, { PureComponent } from 'react';
import { compose } from 'redux';
import cn from 'classnames';
import PropTypes from 'prop-types';
import injectSheet from './styleWaitlistForm';
import connect from './connectWaitlistForm';
import CtaButton from '../CtaButton';
import Title from '../Title';
import { richtextType } from '../../propTypes/richtext';

export const DEFAULT_SUCCESS_MESSAGE = 'AWESOME! You’re signed up.';

class WaitlistForm extends PureComponent {
  state = {
    email: '',
    gender: 'female',
  };

  onSignUpClick = e => {
    const {
      signUpClick, sliceId, source, list,
    } = this.props;
    const { email, gender } = this.state;
    signUpClick(sliceId, {
      email,
      gender,
      source,
      list,
    });
    e.preventDefault();
  };

  onJonNowClick = e => {
    const { sliceId, toggleVisibility } = this.props;
    toggleVisibility(sliceId);
    e.preventDefault();
  };

  onInputChanged = name => e => {
    this.setState({ [name]: e.target.value });
  };

  renderSubmitButton = ({ defaultText, ...rest }) => (
    <button type="submit" {...rest} />
  );

  renderButton = ({ defaultText, ...rest }) => (
    <button type="button" {...rest} />
  );

  renderRichText = html => (
    <div dangerouslySetInnerHTML={{ __html: html }} /> // eslint-disable-line react/no-danger
  );

  renderTitle() {
    const { classes, title } = this.props;
    return (
      <Title className={classes.title} tag="h3">
        {title}
      </Title>
    );
  }

  renderForm = () => {
    const {
      classes, emailPlaceholder, error, copy, busy,
    } = this.props;
    const { email, gender } = this.state;
    return (
      <form className={classes.form} onSubmit={this.onSignUpClick}>
        <div className={classes.selectContainer}>
          <select value={gender} onChange={this.onInputChanged('gender')}>
            <option value="female">
              Women
            </option>
            <option value="male">
              Men
            </option>
          </select>
        </div>
        <div className={classes.inputContainer}>
          <input
            placeholder={emailPlaceholder}
            type="email"
            required
            value={email}
            onChange={this.onInputChanged('email')}
            disabled={busy}
          />
          <span className={cn(classes.message, !!error && 'errorText')}>
            {error && error}
            {!error && copy && this.renderRichText(copy.html)}
          </span>
        </div>
      </form>
    );
  };

  render() {
    const {
      classes, className, successMessage, submitted, formVisible, ctaMobileText,
    } = this.props;

    return (
      <div className={cn(classes.root, className)}>
        {submitted && this.renderRichText((successMessage && successMessage.html)
          || DEFAULT_SUCCESS_MESSAGE)}
        {!submitted && (
          <>
            <div className={cn(classes.formContainer, { formVisible })}>
              {this.renderTitle()}
              {this.renderForm()}
            </div>
            <div className={cn(classes.joinNowContainer, { formVisible })}>
              <CtaButton
                onClick={this.onJonNowClick}
                className={classes.button}
                defaultText={ctaMobileText || WaitlistForm.defaultProps.ctaMobileText}
                ComponentType={this.renderButton}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}

WaitlistForm.propTypes = {
  signUpClick: PropTypes.func.isRequired,
  toggleVisibility: PropTypes.func.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  copy: richtextType,
  emailPlaceholder: PropTypes.string,
  successMessage: richtextType,
  source: PropTypes.string,
  list: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
  submitted: PropTypes.bool,
  error: PropTypes.string,
  busy: PropTypes.bool,
  className: PropTypes.string,
  formVisible: PropTypes.bool,
  ctaText: PropTypes.string,
  ctaMobileText: PropTypes.string,
};

WaitlistForm.defaultProps = {
  className: undefined,
  title: 'Signup to the waitlist',
  copy: undefined,
  emailPlaceholder: 'Email address',
  successMessage: undefined,
  source: '',
  list: '',
  submitted: false,
  error: undefined,
  busy: false,
  formVisible: false,
  ctaText: 'Join Now',
  ctaMobileText: 'Join the Waitlist',
};

export default compose(connect, injectSheet)(WaitlistForm);
